// ============================================================================
// CabinetBillingTab.tsx — вкладка «Счета/оплаты» кабинета.
//
// Не второй экран счёта: используется существующий MyAccountView (SSoT) на
// существующих RPC — sdk.billing.GetMyBillingAccount (баланс/холды/история)
// и sdk.payments (пополнение: провайдер + сумма → платёж). Сервер сам решает,
// что доступно пользователю; выключенный биллинг — явное состояние экрана.
// Новых proto и серверных прав не требуется.
// ============================================================================

import { CreditCard } from 'lucide-react';
import { MyAccountView } from '@/components/billing/MyAccountView';

export function CabinetBillingTab() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex shrink-0 items-center gap-2 border-b bg-background/60 px-4 py-2">
        <CreditCard className="h-4 w-4 text-primary" />
        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-medium">Счета и оплаты</div>
          <div className="truncate text-[11px] text-muted-foreground">
            Личный счёт: баланс, история операций и пополнение
          </div>
        </div>
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        <div className="mx-auto w-full max-w-3xl">
          <MyAccountView />
        </div>
      </div>
    </div>
  );
}
